import Header from "../../../../Components/Header/Header"
import Sidebar from "../../../../Components/Sidebar/Sidebar"
import React, { useEffect, useState } from 'react'
import EmployeePopup from "./EmployeePopup"
import DeletePopup from "../GardenPopup/DeletePopup"
import { EmployeeDataDDL } from "../../../../Components/CommonDDL/EmployeeDataDDL"
import { useSearchParams } from "react-router-dom"
import { useAuthState } from "../../../../Helper/Context"
import { useDispatch, useSelector } from "react-redux"
import { EmployeeDeleteAPI, EmployeeTableDataAPI } from "../../../../Redux/SidebarMasterSlice/EmployeeSlice"
import { Pegination } from "../../../../Components/Pegination/Pegination"
import { Loading } from "../../../../Helper/Loading"
import { DesignationDDL } from "../../../../Components/CommonDDL/DesignationDDL"
import { useTranslation } from "react-i18next"

export const Employee = () => {

    const { t } = useTranslation()

    const userDetails = useAuthState();
    const { UserID, token } = userDetails
    const dispatch = useDispatch()

    const [searchParams] = useSearchParams()
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")
    let Lang = searchParams.get("Lang")

    // ----------pagination-------------
    const [PerPageCount, setPerPageCount] = useState(10)
    const [From, setFrom] = useState(1)
    const [To, setTo] = useState(10)
    const [rowNo, setrowNo] = useState(1)
    const [CurrentPage, setCurrentPage] = useState(0)
    const [DeletePopupShow, setDeletePopupShow] = useState()
    const [IsPost, setIsPost] = useState(false)
    const [apiFlag, setapiFlag] = useState('')
    const [rowData, setrowData] = useState('')
    const [IsClear, setIsClear] = useState(false)

    const [EmployeePopupShow, setEmployeePopupShow] = useState()

    const handleAddOnClick = () => {
        setapiFlag('Insert')
        setEmployeePopupShow(true)
    }
    const handleEditOnClick = (item) => {
        setEmployeePopupShow(true)
        setapiFlag('Update')
        setrowData(item)
    }

    const handleOnCloseClick = () => {
        setEmployeePopupShow(false)
    }

    const [Department, setDepartment] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [EmployeeDDL, setEmployeeDDL] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [Designation, setDesignation] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })


    const [Language, setLanguage] = useState({
        DDL: [],
        ID: 0,
        Label: ''
    })

    useEffect(() => {
        setLanguage({
            ...Language,
            DDL: [],
            ID: 0,
            Label: localStorage.getItem('LanguageChange'),
        })
    }, [])

    const handleIsPost = () => {
        setIsPost(!IsPost)
    }

    const handleDeleteApi = (item) => {
        const data = {
            M_EmployeeID: item.m_EmployeeID,
            M_UserID: UserID,
            token: token,
            handleIsPost: handleIsPost
        }
        dispatch(EmployeeDeleteAPI({ data }))
    }

    const { isDeleteLoading } = useSelector(state => state.EmployeeDeleteData)

    const handleClear = () => {
        setFrom(1)
        setTo(10)
        setCurrentPage(0)
        setIsClear(!IsClear)
        setDepartment({
            ...Department,
            ID: 0,
            Label: 'Select...'
        })
        setEmployeeDDL({
            ...EmployeeDDL,
            ID: 0,
            Label: 'Select...'
        })
        setDesignation({
            ...Designation,
            ID: 0,
            Label: 'Select...'
        })
    }

    // useEffect(() => {
    //     setCurrentPage(0)
    //     setFrom(1)
    //     setTo(10)
    // }, [Designation.ID, EmployeeDDL.ID])

    useEffect(() => {
        const data = {
            M_EmployeeID: EmployeeDDL.ID,
            M_DesignationID: Designation.ID,
            EmployeeName: '',
            M_UsersID: UserID,
            token: token,
            From: From,
            To: To,
        }
        dispatch(EmployeeTableDataAPI({ data }))
    }, [IsPost, To, Department.ID, EmployeeDDL.ID, Designation.ID, IsClear])

    const { tableData, isLoading } = useSelector(state => state.EmployeeTableData)

    return (
        <>
            {isLoading && <Loading />}
            {isDeleteLoading && <Loading />}
            <div>
                <Header
                    DashboardName={DashboardName}
                    Language={Language}
                    setLanguage={setLanguage}
                />
                <div className="wrapper">
                    <Sidebar
                        Language={Language}
                        ProjectTypeId={ProjectTypeId} />
                    <div className="content">
                        <div className="data_mob">
                            <div className="row  m-1 py-1 pb-4 master_border">
                                <div>
                                    <h5 className="ps-1 py-1">{t('AdminDashboard.Admin_Sidebar_Grid_Heading.Employee_Master')}</h5>
                                    <div className="col-12 col-lg-7 float-end ">
                                        <i className="fa-solid fa-plus float-end btn btn-secondary mb-2"
                                            style={{ color: "white", marginTop: '-2.5em' }} onClick={handleAddOnClick}
                                        >
                                            <text className="ml-2 poppins">Add</text>
                                        </i>

                                    </div>
                                </div>
                                <div className="row m-0 ">
                                    <div className="col-12 py-1  rounded rounded-2 shadow"
                                        style={{ border: "1px solid #00000024", background: " #27466317" }}>
                                        <div className="col-12  ">

                                            <div className="row py-1 rounded2 d-flex">

                                                <div className="col-12 col-md-5 col-lg-3">
                                                    <DesignationDDL
                                                        Designation={Designation}
                                                        setDesignation={setDesignation}
                                                        Department='0'
                                                        IsPost={IsPost}
                                                    />
                                                </div>

                                                <div className="col-12 col-md-5 col-lg-3 ">
                                                    <EmployeeDataDDL
                                                        EmployeeDDL={EmployeeDDL}
                                                        setEmployeeDDL={setEmployeeDDL}
                                                        Department='0'
                                                        Designation={Designation}
                                                        IsPost={IsPost}
                                                    />
                                                </div>
                                                <div className="col-12 col-lg-2 col-md-1 mt-lg-4 mt-md-4" >
                                                    <button type="button" className="btn-clear btn btn-primary"
                                                        onClick={handleClear}
                                                    >Clear</button>
                                                </div>
                                            </div>
                                            <div className="row mob_table table-responsive pt-1">

                                                <table id="totalordergenerated"
                                                    cellPadding="0"
                                                    cellSpacing="0"
                                                    border="0"
                                                    className="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th className="sr_no_col">Sr No.</th>
                                                            <th>Designation</th>
                                                            {/* <th>Department Name</th> */}
                                                            <th>Employee Name</th>
                                                            <th>Mobile Number</th>
                                                            <th>Email Id</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            tableData && tableData.table && tableData.table.length > 0 ? tableData.table.map((item) => (
                                                                <tr style={{ width: '100%' }}>
                                                                    <td style={{ textAlign: "center" }}>{item.rowNum}</td>
                                                                    <td>{item.designationName ? item.designationName : '-'}</td>
                                                                    <td>{item.employeeName ? item.employeeName : '-'}</td>
                                                                    <td>{item.mobileNumber ? item.mobileNumber : '-'}</td>
                                                                    <td>{item.email_ID ? item.email_ID : '-'}</td>
                                                                    <td style={{ textAlign: "center", width: '7%' }}>
                                                                        <span>
                                                                            <i className="fa-solid fa-pen-to-square" title='Edit'
                                                                                style={{ cursor: 'pointer' }}
                                                                                onClick={() => handleEditOnClick(item)}
                                                                            >
                                                                            </i>
                                                                        </span>

                                                                        <DeletePopup
                                                                            open={DeletePopupShow}
                                                                            item={item}
                                                                            handleDeleteApi={handleDeleteApi}
                                                                        />
                                                                    </td>
                                                                </tr>
                                                            ))
                                                                :
                                                                <>No data found</>
                                                        }

                                                    </tbody>

                                                </table>

                                            </div>
                                            {tableData && tableData.table && tableData.table.length > 0 &&
                                                <Pegination
                                                    PerPageCount={PerPageCount}
                                                    TotalCount={tableData.table[0].totalCount}
                                                    setFrom={setFrom}
                                                    setTo={setTo}
                                                    setrowNo={setrowNo}
                                                    CurrentPage={CurrentPage}
                                                    setCurrentPage={setCurrentPage}
                                                    IsClear={IsClear}
                                                />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    EmployeePopupShow ?
                        <EmployeePopup
                            open={EmployeePopupShow}
                            handleIsPost={handleIsPost}
                            handleOnCloseClick={handleOnCloseClick}
                            Flag={apiFlag}
                            rowData={rowData}
                        />
                        : <></>
                }
            </div>
        </>
    )
}